import React, { useState } from 'react';
import { TextField, Button, Box, Container, Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import YTCLogo from '../Assets/15.svg';
import BgImage from '../Assets/color-sharp.png';


const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://backend.thegameofthemoney.com/admin/login',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            'access-key': 'ASDFGHJ23456$^%$*&dhsjdhshLMKNGBHGsjdgash23bsh'
          },
        }
      );

      if (response.status === 200) {
        setError(null);
        alert('Login successful!');
        sessionStorage.setItem('email', formData.email);
        navigate('/Leadpage');
      } else {
        setError('Failed to login. Please check your credentials.');
      }
    } catch (error) {
      setError('Failed to login. Please check your credentials.');
    }
  };

  return (
    <Box
      sx={{
        backgroundImage:`url(${BgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={6}>
            <Paper
              elevation={5}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                padding: '20px',
                borderRadius: '8px',
                textAlign: 'center',
              }}
            >
              <Box mb={2}>
                <img src={YTCLogo} alt="YTC Logo" style={{ width: '100px', marginBottom: '20px' }} />
              </Box>
              <Typography variant="h5" sx={{ color: '#333', marginBottom: '20px' }}>
                Admin Login
              </Typography>
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <TextField
                    fullWidth
                    label="Email address"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: { color: '#000' },
                    }}
                  />
                </Box>
                <Box mb={2}>
                  <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: { color: '#000' },
                    }}
                  />
                </Box>
                {error && <Typography color="error" variant="body2">{error}</Typography>}
                <Button variant="contained" color="primary" type="submit" fullWidth sx={{ marginTop: '20px' }}>
                  Login
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AdminLogin;
